import { AloBase, getDefaultAloBase } from './AloBase'
import { AloMailSkinLg } from './AloMailSkinLg'


export interface AloMailSkin extends AloBase {          
    mskValide:boolean    
    lgs:Array<AloMailSkinLg>    
}

export const getDefaultAloMailSkin = ():AloMailSkin => {
    return {        
        ...getDefaultAloBase(),        
        mskValide:true,
        lgs:[]

    }
}

export const cleanAloMailSkin = (mailSkin:AloMailSkin) => {
    if(!mailSkin) return    
    if(!mailSkin.id) delete mailSkin.id
}
